import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'
import { withRouter } from 'react-router'
import compose from '@shopify/react-compose'

import Login from './login-view'
import { withEndUser } from '@portal/kit/pkg/components'
import { loginValidator } from '@portal/kit/pkg/services'

const LoginContainer = ({ user, location }) =>
  <Form
    onSubmit={user.loginUser}
    validate={loginValidator}
    render={formProps => <Login {...formProps} />}
    external_error_code={new URLSearchParams(location.search).get('error_code') || undefined}
  />

LoginContainer.propTypes = {
  user: PropTypes.object.isRequired,
}

export default compose(
  withEndUser,
  withRouter,
)(LoginContainer)
